import React, { Component } from 'react';
import { View, TouchableWithoutFeedback, Animated } from 'react-native';

import PropTypes from 'prop-types';

import { VFText, Icon, IconTypes } from '@vfgroup-oneplatform/foundation/Components';
import {
  withTheme,
  getThemeImages,
  LightThemeColors,
} from '@vfgroup-oneplatform/foundation/Components/Themes';
import { isIPhoneDeviceWithNotch } from '@vfgroup-oneplatform/foundation/Utils/Platform';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';

import styles from './Modal.Styles';
import { isBusinessChooser } from '../../../../../../../App/Utils';

const isIPhoneWithNotch = isIPhoneDeviceWithNotch();

class Modal extends Component {
  static getDerivedStateFromProps(props, state) {
    if (props.isVisible && !state.isVisible) {
      return { isVisible: true };
    }

    return null;
  }

  constructor(props) {
    super(props);

    this.state = {
      isVisible: props.isVisible,
    };

    this.animation = new Animated.Value(0);
  }

  onClose = () => {
    this.props.toggleModal();
  };

  onAnimationFinish = isVisible => {
    if (!isVisible) {
      this.setState({ isVisible: false });
    }
  };

  render() {
    const { lottieViewHeight: _lottieViewHeight, title, content, theme, animation } = this.props;

    const Images = getThemeImages(theme.name);
    const lottieViewHeight = isBusinessChooser() ? _lottieViewHeight + 35 : _lottieViewHeight;

    const { isVisible } = this.state;

    return content && isVisible ? (
      <Animated.View
        style={[styles.modalStyle, { height: lottieViewHeight }, animation]}
        accessibilityLabel={FrameworkTestKeys.modalAnimatedView}
        testID={FrameworkTestKeys.modalAnimatedView}
      >
        <View style={styles.headerStyle} testID={FrameworkTestKeys.modalView}>
          <VFText
            testKey={FrameworkTestKeys.modalTitle}
            style={styles.titleStyle(theme)}
            i18nKey={title}
          />
          <TouchableWithoutFeedback
            accessibilityLabel={FrameworkTestKeys.modalCloseBtn}
            onPress={this.onClose}
            hitSlop={{
              top: 10,
              bottom: 10,
              left: 12,
              right: 12,
            }}
          >
            <Icon
              type={IconTypes.image}
              name={Images.ic_close}
              size={24}
              testID={FrameworkTestKeys.modalIcon}
            />
          </TouchableWithoutFeedback>
        </View>

        <View style={styles.modalContent} testID={FrameworkTestKeys.modalContentView}>
          {content}
        </View>
      </Animated.View>
    ) : null;
  }
}

Modal.defaultProps = {
  theme: LightThemeColors,
};

Modal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  content: PropTypes.object,
  isVisible: PropTypes.bool,
  action: PropTypes.string,
  title: PropTypes.string,
  theme: PropTypes.object,
  lottieViewHeight: PropTypes.number,
  accessibilityID: PropTypes.string,
  animation: PropTypes.object,
};

export default withTheme(Modal);
